import {Avatar, Typography} from "@material-tailwind/react";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {getFileUrl} from "../../../config";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";


const TABLE_HEAD = ["#", "کاربر", "پروفایل", "وضعیت", "اولین ورود", "آخرین ورود"];

export function UserRoleReportGrid({
                                     userReport,
                                   }) {
  const avatar = '/assets/blank_profile.jpg';

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "کاربر": "name",
    "پروفایل": "photo",
    "نقش": "role",
    "وضعیت": "status",
    "اولین ورود": "first_login",
    "آخرین ورود": "last_login",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "پروفایل": false,
    "نقش": true,
    "وضعیت": true,
    "اولین ورود": true,
    "آخرین ورود": true,
  }

  return (
    <div className="w-full">
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {userReport.map(
          ({
             id,
             name,
             family,
             photo,
             role,
             phone,
             balance,
             status,
             first_login,
             last_login
           }, index) => {
            const isLast = index === userReport.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    {photo.length > 0 &&
                      <Avatar variant="circular" alt="tania andrew"
                              className="cursor-pointer border-white"
                              withBorder={true} size="sm"
                              src={getFileUrl(photo)}
                      />
                    }
                    {photo.length === 0 &&
                      <Avatar variant="circular" alt="tania andrew"
                              className="cursor-pointer border-white"
                              withBorder={true} size="sm"
                              src={avatar}
                      />
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(first_login)}
                    </Typography>
                  </div>
                </td>


                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(last_login)}
                    </Typography>
                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}